#@import Booking.Presenters.Picker
#@export Booking.Presenters.PartyPicker

class Booking.Presenters.PartyPicker extends Booking.Presenters.Picker

  selected: ->
    @model.getSelectedPartySize()

  toHash: ->
    hash = Booking.Presenters.Picker::toHash.apply this, arguments

    selectedPartySize = @selected()

    if selectedPartySize?
      hash.selectedpartySize =
        partySize: selectedPartySize

    hash
